import {
  AboutUs,
  Featured,
  WhatWeDo,
} from "../components/common/page-components";
import {
  Filters,
  GetInTouch,
  Hero,
} from "../components/home";

const Home = () => {
  return (
    <div className="md:pt-[5.2rem] pt-10">
      <Hero />
      <Filters />
      <div className="mt-10 px-[3%] md:px-[6%]">
        <AboutUs />
        <WhatWeDo />
        <Featured />
        <GetInTouch />
      </div>
    </div>
  );
};

export default Home;
